export default "__VITE_ASSET__BqGEE3dP__"